import React from "react";
import ReactGA from "react-ga4";

const VimeoEmbed = ({ videoId, title }) => {
  const handleVideoPlay = () => {
    ReactGA.event({
      category: "Video",
      action: "Play",
      label: "About StratCap Digital Infrastructure REIT, Inc. - Vimeo Video", // Optional: Add more context
    });
  };
  return (
    <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
      <iframe
        src={`https://player.vimeo.com/video/${videoId}?badge=0&autopause=0&player_id=0&app_id=58479`}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        title={title}
        onPlay={handleVideoPlay} // Attach the event handler
      ></iframe>
    </div>
  );
};

export default VimeoEmbed;
